import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-stone-50 py-16 md:py-24" data-id="element-55" data-mp="15capavgsvj0g">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-56" data-mp="1jd4znjneru1r">
        {showUrgency && <CountdownPanel headline="L’offre de lancement se termine dans :" subtext={`Aujourd’hui : ${offer.price}\u00A0${offer.currency} avec 3 bonus inclus. Prix habituel : ${offer.listPrice}.`} data-id="element-57" data-mp="1ee1w63n2tvvw" />}

        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-58" data-mp="1o4wkrensp7ki">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-59" data-mp="223mjeyq9jfaz">
            Votre action Octobre Rose ne doit pas commencer devant une page blanche
          </h2>

          <p className="mt-6 text-lg leading-relaxed text-neutral-500 md:text-xl" data-id="element-60" data-mp="n5umo42k7rht">
            Vous pouvez passer des heures à chercher des idées, créer vos supports et vous demander
            comment organiser votre animation. Ou partir d’une boîte à outils déjà structurée.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-neutral-500 md:text-xl" data-id="element-61" data-mp="122lm2dc8h37f">
            50 Cartes de Réflexion. 150 Marque-pages Inspirants. Un Guide d’Animation de 50 pages.
            Et 3 bonus pour vous aider à préparer et animer votre action plus sereinement.{' '}
            <span className="font-extrabold text-neutral-800" data-id="element-62" data-mp="1b170pxel3y2x">
              Tout est prêt. Il ne reste plus qu’à l’adapter à votre groupe.
            </span>
          </p>

          <div className="mx-auto mt-9 w-fit rounded-2xl bg-white px-8 py-6 shadow-sm ring-1 ring-neutral-200" data-id="element-63" data-mp="1kstlakctb9ic">
            <p className="text-4xl font-extrabold leading-none tracking-tight text-pink-900 md:text-5xl" data-id="element-64" data-mp="1puagbz8m81r0">
              {`Aujourd’hui\u00A0: ${offer.price}\u00A0${offer.currency}`}
            </p>
            <p className="mt-3 text-neutral-500" data-id="element-65" data-mp="3qux8wj3i3syh">
              Prix habituel : <span className="line-through" data-id="element-66" data-mp="3lwnc6424okar">{offer.listPrice}</span>
            </p>
          </div>

          <div className="mt-10" data-id="element-67" data-mp="3imry82iqn9n">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-68" data-mp="3jpj8h3r6rq3">
              {offer.cta}
            </CtaButton>
          </div>

          <TrustIcons className="mt-8" data-id="element-69" data-mp="df9dkz2o5icq" />
        </div>
      </div>
    </section>;
}